const accessToken = process.env.REACT_APP_MAPBOX_KEY;

export default accessToken;